import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=7c886a20&"
import script from "./phoneLogin.vue?vue&type=script&lang=js&"
export * from "./phoneLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c886a20')) {
      api.createRecord('7c886a20', component.options)
    } else {
      api.reload('7c886a20', component.options)
    }
    module.hot.accept("./phoneLogin.vue?vue&type=template&id=7c886a20&", function () {
      api.rerender('7c886a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/loginComponent/phoneLogin.vue"
export default component.exports